import { getAuth } from "firebase/auth";

const API_BASE_URL =
  process.env.REACT_APP_API_URL || "http://localhost:4000/api";

/**
 * PATCH /api/units/:id: syndication fields, tenant Leo chat fields, etc.
 * @param {string} unitId
 * @param {Record<string, unknown>} data
 */
export async function patchUnit(unitId, data) {
  const user = getAuth().currentUser;
  const token = user ? await user.getIdToken() : null;
  if (!token) throw new Error("Not authenticated");
  const res = await fetch(
    `${API_BASE_URL}/units/${encodeURIComponent(unitId)}`,
    {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    }
  );
  if (!res.ok) {
    let body = null;
    try {
      body = await res.json();
    } catch {
      /* ignore */
    }
    const text =
      (body && (body.error || body.message)) ||
      `Failed to update unit (${res.status})`;
    const err = new Error(text);
    err.status = res.status;
    err.code = body?.code;
    err.tier = body?.tier;
    err.cap = body?.cap;
    err.current = body?.current;
    err.body = body;
    throw err;
  }
  return res.json();
}

/**
 * Update unit for syndication (Zillow/Trulia/HotPads feed) or other PATCH fields.
 * @param {string} unitId
 * @param {Record<string, unknown>} data
 */
export async function updateUnitForSyndication(unitId, data) {
  return patchUnit(unitId, data);
}

/**
 * POST /api/units/:unitId/extract-lease-rules: upload PDF or DOCX; returns { rules: { title, content }[] } (does not save).
 * @param {string} unitId
 * @param {File} file
 */
export async function extractLeaseRules(unitId, file) {
  const user = getAuth().currentUser;
  const token = user ? await user.getIdToken() : null;
  if (!token) throw new Error("Not authenticated");
  const form = new FormData();
  form.append("file", file);
  const res = await fetch(
    `${API_BASE_URL}/units/${encodeURIComponent(unitId)}/extract-lease-rules`,
    {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: form,
    }
  );
  if (!res.ok) {
    let body = null;
    try {
      body = await res.json();
    } catch {
      /* ignore */
    }
    const text =
      (body && (body.error || body.message)) ||
      `Extraction failed (${res.status})`;
    const err = new Error(text);
    err.status = res.status;
    err.body = body;
    throw err;
  }
  return res.json();
}
